/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_decrease_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find out how much a value has dropped in percentage terms. Enter the original value and the new value to get the percentage decrease.`)
};

const es_pct_decrease_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubre cuánto ha caído un valor en términos porcentuales. Introduce el valor original y el valor nuevo para obtener la disminución porcentual.`)
};

const de_pct_decrease_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finde heraus, wie stark ein Wert prozentual gesunken ist. Gib den Ausgangswert und den neuen Wert ein, um den prozentualen Rückgang zu erhalten.`)
};

const nl_pct_decrease_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontdek hoeveel een waarde is gedaald, uitgedrukt in procenten. Vul de oorspronkelijke waarde en de nieuwe waarde in om de percentagedaling te krijgen.`)
};

const fr_pct_decrease_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découvrez de combien une valeur a baissé en pourcentage. Entrez la valeur d'origine et la nouvelle valeur pour obtenir la diminution en pourcentage.`)
};

const it_pct_decrease_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri di quanto è diminuito un valore in termini percentuali. Inserisci il valore originale e il nuovo valore per ottenere il calo percentuale.`)
};

const pt_br2_pct_decrease_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubra o quanto um valor caiu em termos percentuais. Insira o valor original e o novo valor para obter a diminuição percentual.`)
};

const pt_pct_decrease_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubra quanto um valor diminuiu em termos percentuais. Insira o valor original e o novo valor para obter a diminuição percentual.`)
};

const ja_pct_decrease_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`値がパーセントでどれだけ下落したかを求めます。元の値と新しい値を入力するとパーセント減少が分かります。`)
};

const zh_pct_decrease_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解一个数值以百分比形式下降了多少。输入原始值和新值即可得到百分比减少。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_decrease_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_decrease_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_decrease_intro", locale)
	if (locale === "en") return en_pct_decrease_intro(inputs)
	if (locale === "es") return es_pct_decrease_intro(inputs)
	if (locale === "de") return de_pct_decrease_intro(inputs)
	if (locale === "nl") return nl_pct_decrease_intro(inputs)
	if (locale === "fr") return fr_pct_decrease_intro(inputs)
	if (locale === "it") return it_pct_decrease_intro(inputs)
	if (locale === "pt-BR") return pt_br2_pct_decrease_intro(inputs)
	if (locale === "pt") return pt_pct_decrease_intro(inputs)
	if (locale === "ja") return ja_pct_decrease_intro(inputs)
	return zh_pct_decrease_intro(inputs)
};